/**
 * 手帳の画面上の呼び名（PRODUCT_DEV-970）。下部ナビのタブ・ロゴの読み上げ・「〜へ戻る」が
 * すべてこれを使う。戻る場所（ホーム）らしさを出すために「手帳」から「マイ手帳」にした。
 */
export const DIARY_HOME_LABEL = "マイ手帳";
